export const ATT_DASH_NECESSARY_FILTERS = [
    "startDate",
    "endDate",
    "metrics"
];
//# sourceMappingURL=index.js.map